const items = document.querySelectorAll('.item-accordion');  

function hideOthers(currentItem) {  
    items.forEach(item => {  
        if (item !== currentItem) {  
            item.classList.remove('active') 
        }  
    });  
}  

items.forEach(item => {  
    item.addEventListener('mouseenter', () => {  
        hideOthers(item);  
        item.classList.add('active')
    });  
});